module.exports = __webpack_public_path__ + "images/images/drawer-logo-full-logo_ppa.fr_CA-a6215054281886b2f56f270fd9a39b08.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/drawer-logo-full-logo_ppa.fr_CA.png
// module id = 2525
// module chunks = 2